module.exports = __webpack_public_path__ + "0c0d042640a915e43fa3242dd7e961a0.jpg";